module.exports = __webpack_public_path__ + "static/media/visa-logo.7793c18b.svg";